import { Link, useLocation } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import PrimeButton from '../Button/Button';
import './TileHeader.scss';

const TileHeaderButton = ({
  title,
  subtitle,
  size = "md",
  style = {},
  onClick = () => {},
  buttonText = "",
  disabled = false,
  hideBreadcrumb = false,
}) => {
  const location = useLocation();

  const pathname = window.location.pathname.split('/');
  let client = '';
  if (pathname.length > 1) { client = pathname[1]; }

  return (
    <div className="tile-header-button" style={style}>
      <div style={{ marginRight: 'auto' }}>
        {!hideBreadcrumb && (
          <div className="tile-header__breadcrumb">
            {location.pathname === `/${client}` ? (
              <span>Dashboard</span>
            ) : (
              <Link to={`/${client}`}>Dashboard</Link>
            )}
            <ChevronRight className="chevron" />
            <span>{title}</span>
          </div>
        )}
        <div className={`tile-header__title tile-header__title--${size}`}>{title}</div>
        {subtitle ? <div className="tile-header__subtitle">{subtitle}</div> : null}
      </div>
      <PrimeButton
        onClick={onClick}
        disabled={disabled}
      >
        {buttonText}
      </PrimeButton>
    </div>
  );
};

export default TileHeaderButton;
